export default {
      id: "plus-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#plus-usage",
      toString: function () {
        return this.url;
      }
    }